var Isotope = require('isotope-layout');
import PhotoSwipe from 'photoswipe';

import { initProjectGallery } from './../components/projectGallery';



const initGallery = (container = document) => {

  var projectGallery = container.querySelector('.project-gallery');

  Promise.all(Array.from(document.images).filter(img => !img.complete).map(img => new Promise(resolve => { img.onload = img.onerror = resolve; }))).then(() => {

    var iso = new Isotope(projectGallery, {
      itemSelector: '.gallery-item',
      layoutMode: 'masonry'
    });

    setTimeout(() => {
      initProjectGallery(container);
    }, 1000);
  });
}



/*
 * barba views
 */
const Project = {
  namespace: 'project',
  beforeEnter: (data) => {
  },
  afterEnter: (data) => {
    initGallery(data.next.container);
  }
}

export default Project;
